import { GET_EMBARK_GROUPS_SUCCESS } from "../actionTypes";

const initialState = {
  embarkGroups: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_EMBARK_GROUPS_SUCCESS: {
      const embarkGroups = action.payload;

      return {
        ...state,
        embarkGroups: [ ...embarkGroups ]
      }
    }

    default:
      return state;
  }
}
